export const postalCoderegexes = [
  {
    Note: 'The first two digits (ranging from 10–43) correspond to the province, while the last two digits correspond either to the city/delivery zone (range 01–50) or to the district/delivery zone (range 51–99). Afghanistan Postal code lookup',
    country: 'Afghanistan',
    ISO: 'AF',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'With Finland, first two numbers are 22.',
    country: 'Åland Islands',
    ISO: 'AX',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Introduced in 2006, gradually implemented throughout 2007.',
    country: 'Albania',
    ISO: 'AL',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'First two as in ISO 3166-2:DZ',
    country: 'Algeria',
    ISO: 'DZ',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'U.S. ZIP codes (range 96799)',
    country: 'American Samoa',
    ISO: 'AS',
    Format: 'NNNNN (optionally NNNNN-NNNN or NNNNN-NNNNNN)',
    regex: '^\\d{5}(-{1}\\d{4,6})$',
  },
  {
    Note: 'Each parish now has its own post code.',
    country: 'Andorra',
    ISO: 'AD',
    Format: 'CCNNN',
    regex: '^[Aa][Dd]\\d{3}$',
  },
  {
    Note: '',
    country: 'Angola',
    ISO: 'AO',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Single code used for all addresses.',
    country: 'Anguilla',
    ISO: 'AI',
    Format: 'AI-2640',
    regex: '^[Aa][I][-][2][6][4][0]$',
  },
  {
    Note: '',
    country: 'Antigua and Barbuda',
    ISO: 'AG',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Codigo Postal Argentino (CPA), where the first A is the province code as in ISO 3166-2:AR, the four numbers are the old postal codes, the three last letters indicate a side of the block. Previously NNNN which &#10;o the minimum requirement as of 2006.',
    country: 'Argentina',
    ISO: 'AR',
    Format: '1974-1998 NNNN; From 1999 ANNNNAAA',
    regex: '^\\d{4}|[A-Za-z]\\d{4}[a-zA-Z]{3}$',
  },
  {
    Note: 'Previously used NNNNNN system inherited from former Soviet Union.',
    country: 'Armenia',
    ISO: 'AM',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Aruba',
    ISO: 'AW',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Single code used for all addresses. Part of UK system.',
    country: 'Ascension island',
    ISO: 'AC',
    Format: 'AAAANAA one code: ASCN 1ZZ',
    regex: '^[Aa][Ss][Cc][Nn]\\s{0,1}[1][Zz][Zz]$',
  },
  {
    Note: 'In general, the first digit identifies the state or territory.',
    country: 'Australia',
    ISO: 'AU',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'The first digit denotes regions, which are partly identical to one of the nine provinces—called Bundesländer; the last the nearest post office in the area.',
    country: 'Austria',
    ISO: 'AT',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Previously used NNNNNN system inherited from former Soviet Union.',
    country: 'Azerbaijan',
    ISO: 'AZ',
    Format: 'CCNNNN',
    regex: '^[Aa][Zz]\\d{4}$',
  },
  {
    Note: '',
    country: 'Bahamas',
    ISO: 'BS',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: "Valid post code numbers are 101 to 1216 with gaps in the range. Known as block number (Arabic: رقم المجمع‎) formally. The first digit in NNN format and the first two digits in NNNN format refer to one of the 12 municipalities of the country. PO Box address doesn't need a block number or city name, just the PO Box number followed by the name of the country, Bahrain.",
    country: 'Bahrain',
    ISO: 'BH',
    Format: 'NNN or NNNN',
    regex: '^\\d{3,4}$',
  },
  {
    Note: '',
    country: 'Bangladesh',
    ISO: 'BD',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Only one postal code currently assigned. 11000 applies to the General Post Office building in Cheapside, Bridgetown, to enable delivery to Barbados by global package delivery companies whose software requires a postal code.',
    country: 'Barbados',
    ISO: 'BB',
    Format: 'CCNNNNN',
    regex: '^[Aa][Zz]\\d{5}$',
  },
  {
    Note: 'Retained system inherited from former Soviet Union.',
    country: 'Belarus',
    ISO: 'BY',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'In general, the first digit gives the province.',
    country: 'Belgium',
    ISO: 'BE',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Belize',
    ISO: 'BZ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Benin',
    ISO: 'BJ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'AA NN for street addresses, AA AA for P.O. Box addresses. The second half of the postcode identifies the street delivery walk (e.g.: Hamilton HM 12) or the PO Box number range (e.g.: Hamilton HM BX). See Postal codes in Bermuda.',
    country: 'Bermuda',
    ISO: 'BM',
    Format: 'AA NN or AA AA',
    regex: '^[A-Za-z]{2}\\s([A-Za-z]{2}|\\d{2})$',
  },
  {
    Note: '',
    country: 'Bhutan',
    ISO: 'BT',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Bolivia',
    ISO: 'BO',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Bonaire, Sint Eustatius and Saba',
    ISO: 'BQ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Bosnia and Herzegovina',
    ISO: 'BA',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Botswana',
    ISO: 'BW',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Código de Endereçamento Postal (CEP): -000 to -899 are used for streets, roads, avenues, boulevards; -900 to -959 are used for buildings with a high postal use; -960 to -969 are for promotional use; -970 to -989 are post offices and regular P.O. boxes; and -990 to -998 are used for community P.O. boxes. -999 is used for special services.',
    country: 'Brazil',
    ISO: 'BR',
    Format: 'NNNNN-NNN (NNNNN from 1971 to 1992)',
    regex: '^\\d{5}-\\d{3}$',
  },
  {
    Note: 'Single code used for all addresses.',
    country: 'British Antarctic Territory',
    ISO: '',
    Format: 'BIQQ 1ZZ',
    regex: '^[Bb][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: 'UK territory, but not UK postcode.',
    country: 'British Indian Ocean Territory',
    ISO: 'IO',
    Format: 'AAAANAA one code: BBND 1ZZ',
    regex: '^[Bb]{2}[Nn][Dd]\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: 'Specifically, VG1110 through VG1160[1]',
    country: 'British Virgin Islands',
    ISO: 'VG',
    Format: 'CCNNNN',
    regex: '^[Vv][Gg]\\d{4}$',
  },
  {
    Note: '',
    country: 'Brunei',
    ISO: 'BN',
    Format: 'AANNNN',
    regex: '^[A-Za-z]{2}\\d{4}$',
  },
  {
    Note: '',
    country: 'Bulgaria',
    ISO: 'BG',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Burkina Faso',
    ISO: 'BF',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Burundi',
    ISO: 'BI',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Cambodia',
    ISO: 'KH',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Cameroon',
    ISO: 'CM',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'The system was gradually introduced starting in April 1971 in Ottawa. The letters D, F, I, O, Q, and U are not used to avoid confusion with other letters or numbers.',
    country: 'Canada',
    ISO: 'CA',
    Format: 'ANA NAN',
    regex:
      '^(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\s{0,1}\\d(?=[^DdFfIiOoQqUu\\d\\s])[A-Za-z]\\d$',
  },
  {
    Note: 'The first digit indicates the island.',
    country: 'Cape Verde',
    ISO: 'CV',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Cayman Islands',
    ISO: 'KY',
    Format: 'CCN-NNNN',
    regex: '^[Kk][Yy]\\d[-\\s]{0,1}\\d{4}$',
  },
  {
    Note: '',
    country: 'Central African Republic',
    ISO: 'CF',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Chad',
    ISO: 'TD',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'May only be required for bulk mail.',
    country: 'Chile',
    ISO: 'CL',
    Format: 'NNNNNNN (NNN-NNNN)',
    regex: '^\\d{7}\\s\\(\\d{3}-\\d{4}\\)$',
  },
  {
    Note: 'A postal code or youbian (邮编) in a subordinate division will have the same first two digits as its governing one (see Political divisions of China. The postal services in Macau or Hong Kong Special Administrative Regions remain separate from Mainland China, with no post code system currently used.',
    country: 'China',
    ISO: 'CN',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Part of the Australian postal code system.',
    country: 'Christmas Island',
    ISO: 'CX',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Part of the Australian postal code system.',
    country: 'Cocos (Keeling) Island',
    ISO: 'CC',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'First NN = 32 departments Códigos Postales | 4-72',
    country: 'Colombia',
    ISO: 'CO',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: '',
    country: 'Comoros',
    ISO: 'KM',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Congo (Brazzaville)',
    ISO: 'CG',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Congo, Democratic Republic',
    ISO: 'CD',
    Format: '- no codes -',
    regex: '^[Cc][Dd]$',
  },
  {
    Note: '',
    country: 'Cook Islands',
    ISO: 'CK',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'First codes the provinces, next two the canton, last two the district.',
    country: 'Costa Rica',
    ISO: 'CR',
    Format: 'NNNNN (NNNN until 2007)',
    regex: '^\\d{4,5}$',
  },
  {
    Note: '',
    country: "Côte d'Ivoire (Ivory Coast)",
    ISO: 'CI',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Croatia',
    ISO: 'HR',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'May only be required for bulk mail. The letters CP are frequently used before the postal code. This is not a country code, but an abbreviation for "codigo postal" or postal code.',
    country: 'Cuba',
    ISO: 'CU',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Curaçao',
    ISO: 'CW',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: "Post code system covers whole island, but not used in Northern Cyprus where 'Mersin 10, Turkey' is used instead.",
    country: 'Cyprus',
    ISO: 'CY',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'With Slovak Republic, Poštovní směrovací číslo (PSČ) - postal routing number.',
    country: 'Czech Republic',
    ISO: 'CZ',
    Format: 'NNNNN (NNN NN)',
    regex: '^\\d{5}\\s\\(\\d{3}\\s\\d{2}\\)$',
  },
  {
    Note: 'Numbering follows the dispatch of postal trains from Copenhagen.[3] Also used by Greenland, e.g.: DK-3900 Nuuk.',
    country: 'Denmark',
    ISO: 'DK',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Djibouti',
    ISO: 'DJ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Dominica',
    ISO: 'DM',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Dominican Republic',
    ISO: 'DO',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'No postal code system in use since Indonesian withdrawal in 1999.',
    country: 'East Timor',
    ISO: 'TL',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Ecuador',
    ISO: 'EC',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Used for all inbound mail to El Salvador. The postal office then distributes the mail internally depending on their destination.',
    country: 'El Salvador',
    ISO: 'SV',
    Format: '1101',
    regex: '^1101$',
  },
  {
    Note: '',
    country: 'Egypt',
    ISO: 'EG',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Equatorial Guinea',
    ISO: 'GQ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Eritrea',
    ISO: 'ER',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Estonia',
    ISO: 'EE',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'The code is only used on a trial basis for Addis Ababa addresses.',
    country: 'Ethiopia',
    ISO: 'ET',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'UK territory, but not UK postcode',
    country: 'Falkland Islands',
    ISO: 'FK',
    Format: 'AAAANAA one code: FIQQ 1ZZ',
    regex: '^[Ff][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: 'Self-governing territory within the Kingdom of Denmark, but not Danish postcode.',
    country: 'Faroe Islands',
    ISO: 'FO',
    Format: 'NNN',
    regex: '^\\d{3}$',
  },
  {
    Note: '',
    country: 'Fiji',
    ISO: 'FJ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'A lower first digit indicates a place in south (for example 00100 Helsinki), a higher indicates a place further to north (99800 in Ivalo). The last digit is usually 0, except for postal codes for PO Box number ranges, in which case it is 1. country code for Finland: "FI". In the Åland Islands, the postal code is prefixed with "AX", not "FI". Some postal codes for rural settlements may end with 5, and there are some unique postal codes for large companies and institutions, e.g. 00014 HELSINGIN YLIOPISTO (university), 00102 EDUSKUNTA (parliament), 00020 NORDEA (a major Scandinavian bank).',
    country: 'Finland',
    ISO: 'FI',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'The first two digits give the département number, while in Paris, Lyon and Marseille, the last two digits of the postal code indicates the arrondissement. Both of the 2 corsican départements use "20" as the first two digits. Also used by French overseas departments and territories. Monaco is also part of the French postal code system, but the country code MC- is used for Monegasque addresses.',
    country: 'France',
    ISO: 'FR',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 97300 - 97390.',
    country: 'French Guiana',
    ISO: 'GF',
    Format: '973NN',
    regex: '^973\\d{2}$',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 98700 - 98790.',
    country: 'French Polynesia',
    ISO: 'PF',
    Format: '987NN',
    regex: '^987\\d{2}$',
  },
  {
    Note: 'French codes in the 98400 range have been reserved.',
    country: 'French Southern and Antarctic Territories',
    ISO: 'TF',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Two digit postal zone goes after city name.',
    country: 'Gabon',
    ISO: 'GA',
    Format: 'NN [city name] NN',
    regex: '^\\d{2}\\s[a-zA-Z-_ ]\\s\\d{2}$',
  },
  {
    Note: '',
    country: 'Gambia',
    ISO: 'GM',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Georgia',
    ISO: 'GE',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Postleitzahl (PLZ)',
    country: 'Germany',
    ISO: 'DE',
    Format: 'NN',
    regex: '^\\d{2}$',
  },
  {
    Note: 'Postleitzahl (PLZ)',
    country: 'Germany',
    ISO: 'DE',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Postleitzahl (PLZ), introduced after the German reunification. Between 1989 and 1993 the old separate 4-digit postal codes of former West- and East-Germany were distinguished by preceding "W-" or "O-" (\'Ost\' for East).',
    country: 'Germany',
    ISO: 'DE',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '[citation needed]',
    country: 'Ghana',
    ISO: 'GH',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Single code used for all addresses.',
    country: 'Gibraltar',
    ISO: 'GI',
    Format: 'GX11 1AA',
    regex: '^[Gg][Xx][1]{2}\\s{0,1}[1][Aa]{2}$',
  },
  {
    Note: '',
    country: 'Greece',
    ISO: 'GR',
    Format: 'NNN NN',
    regex: '^\\d{3}\\s{0,1}\\d{2}$',
  },
  {
    Note: 'Part of the Danish postal code system.',
    country: 'Greenland',
    ISO: 'GL',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Grenada',
    ISO: 'GD',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 97100 - 97190.',
    country: 'Guadeloupe',
    ISO: 'GP',
    Format: '971NN',
    regex: '^971\\d{2}$',
  },
  {
    Note: 'U.S. ZIP codes. Range 96910 - 96932.',
    country: 'Guam',
    ISO: 'GU',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'The first two numbers identify the department, the third number the route and the last two the office.',
    country: 'Guatemala',
    ISO: 'GT',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'UK-format postcode (first two letters are always GY not GG)',
    country: 'Guernsey',
    ISO: 'GG',
    Format: 'AAN NAA, AANN NAA',
    regex: '^[A-Za-z]{2}\\d\\s{0,1}\\d[A-Za-z]{2}$',
  },
  {
    Note: '',
    country: 'Guinea',
    ISO: 'GN',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Guinea Bissau',
    ISO: 'GW',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Guyana',
    ISO: 'GY',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Haiti',
    ISO: 'HT',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Part of the Australian postcode system.',
    country: 'Heard and McDonald Islands',
    ISO: 'HM',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Honduras',
    ISO: 'HN',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '[1] The dummy postal code of Hong Kong is 999077 but it is unnecessary in fact',
    country: 'Hong Kong',
    ISO: 'HK',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'The code defines an area, usually one code per settlement except the six largest towns. One code can identify more (usually) small settlements as well.',
    country: 'Hungary',
    ISO: 'HU',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Iceland',
    ISO: 'IS',
    Format: 'NNN',
    regex: '^\\d{3}$',
  },
  {
    Note: 'Postal Index Number (PIN)',
    country: 'India',
    ISO: 'IN',
    Format: 'NNNNNN,&#10;NNN NNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Kode Pos. Included East Timor (ranges 88xxx and 89xxx) until 1999, no longer used. For Indonesia postal code information visit [2]',
    country: 'Indonesia',
    ISO: 'ID',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '(Persian: کد پستی)',
    country: 'Iran',
    ISO: 'IR',
    Format: 'NNNNN-NNNNN',
    regex: '^\\d{5}-\\d{5}$',
  },
  {
    Note: '',
    country: 'Iraq',
    ISO: 'IQ',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Currently no postal codes; however, Dublin is divided into postal districts on syntax Dublin 9. A national post code system is planned. See also Republic of Ireland postal addresses.',
    country: 'Ireland',
    ISO: 'IE',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'UK-format postcode. The first two letters are always IM.',
    country: 'Isle of Man',
    ISO: 'IM',
    Format: 'CCN NAA, CCNN NAA',
    regex: '^[Ii[Mm]\\d{1,2}\\s\\d\\[A-Z]{2}$',
  },
  {
    Note: "Postcode is always written BEFORE the city/place name, i.e. to the Right in Hebrew or Arabic script - to the Left in Latin script.  This also allows the legacy postal code version (even though deprecated) since it's still in high use.",
    country: 'Israel',
    ISO: 'IL',
    Format: 'NNNNNNN, NNNNN',
    regex: '^\\b\\d{5}(\\d{2})?$',
  },
  {
    Note: 'Codice di Avviamento Postale (CAP). Also used by San Marino and Vatican City. First two digits identify province with some exceptions, because there are more than 100 provinces.',
    country: 'Italy',
    ISO: 'IT',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: "Jamaica currently has no national postal code system, except for Kingston and Lower St. Andrew, which are divided into postal districts numbered 1-20[4] &#10;Before the 2007 suspension, the first two letters of a national post code were always 'JM' (for Jamaica) while the third was for one of the four zones (A-D) into which the island was divided. The last two letters were for the parish, while the two digits were for the local post office.[5]",
    country: 'Jamaica',
    ISO: 'JM',
    Format: 'Before suspension: CCAAANN &#10;After suspension: NN',
    regex: '^\\d{2}$',
  },
  {
    Note: 'See also Japanese addressing system.',
    country: 'Japan',
    ISO: 'JP',
    Format: 'NNNNNNN (NNN-NNNN)',
    regex: '^\\d{7}\\s\\(\\d{3}-\\d{4}\\)$',
  },
  {
    Note: 'UK-format postcode.',
    country: 'Jersey',
    ISO: 'JE',
    Format: 'CCN NAA',
    regex: '^[Jj][Ee]\\d\\s{0,1}\\d[A-Za-z]{2}$',
  },
  {
    Note: 'Deliveries to PO Boxes only.',
    country: 'Jordan',
    ISO: 'JO',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '[6]',
    country: 'Kazakhstan',
    ISO: 'KZ',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: "Deliveries to PO Boxes only. The postal code refers to the post office at which the receiver's P. O. Box is located.",
    country: 'Kenya',
    ISO: 'KE',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Kiribati',
    ISO: 'KI',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Korea, North',
    ISO: 'KP',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Korea, South',
    ISO: 'KR',
    Format: 'NNNNNN (NNN-NNN)(1988~2015)',
    regex: '^\\d{6}\\s\\(\\d{3}-\\d{3}\\)$',
  },
  {
    Note: 'A separate postal code for Kosovo was introduced by the UNMIK postal administration in 2004. Serbian postcodes are still widely used in the Serbian enclaves. No country code has been assigned.',
    country: 'Kosovo',
    ISO: 'XK',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'The first two digits represent the sector and the last three digits represents the post office.',
    country: 'Kuwait',
    ISO: 'KW',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Kyrgyzstan',
    ISO: 'KG',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: '',
    country: 'Latvia',
    ISO: 'LV',
    Format: 'LV-NNNN',
    regex: '^[Ll][Vv][- ]{0,1}\\d{4}$',
  },
  {
    Note: '',
    country: 'Laos',
    ISO: 'LA',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'The first four digits represent the region or postal zone,the last four digits represent the building see also Lebanon Postal code website.',
    country: 'Lebanon',
    ISO: 'LB',
    Format: 'NNNN NNNN',
    regex: '^\\d{4}\\s{0,1}\\d{4}$',
  },
  {
    Note: '',
    country: 'Lesotho',
    ISO: 'LS',
    Format: 'NNN',
    regex: '^\\d{3}$',
  },
  {
    Note: 'Two digit postal zone after city name.',
    country: 'Liberia',
    ISO: 'LR',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Libya',
    ISO: 'LY',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'With Switzerland, ordered from west to east. Range 9485 - 9498.',
    country: 'Liechtenstein',
    ISO: 'LI',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'References: http://www.post.lt/en/help/postal-code-search. Previously 9999 which was actually the old Soviet 999999 format code with the first 2 digits dropped.',
    country: 'Lithuania',
    ISO: 'LT',
    Format: 'LT-NNNNN',
    regex: '^[Ll][Tt][- ]{0,1}\\d{5}$',
  },
  {
    Note: 'References: http://www.upu.int/post_code/en/countries/LUX.pdf',
    country: 'Luxembourg',
    ISO: 'LU',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '[2]',
    country: 'Macau',
    ISO: 'MO',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Macedonia',
    ISO: 'MK',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Madagascar',
    ISO: 'MG',
    Format: 'NNN',
    regex: '^\\d{3}$',
  },
  {
    Note: '',
    country: 'Malawi',
    ISO: 'MW',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Maldives',
    ISO: 'MV',
    Format: 'NNNN, NNNNN',
    regex: '^\\d{4,5}$',
  },
  {
    Note: '',
    country: 'Malaysia',
    ISO: 'MY',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Mali',
    ISO: 'ML',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Kodiċi Postali',
    country: 'Malta',
    ISO: 'MT',
    Format: 'AAANNNN (AAA NNNN)',
    regex: '^[A-Za-z]{3}\\s{0,1}\\d{4}$',
  },
  {
    Note: 'U.S. ZIP codes. Range 96960 - 96970.',
    country: 'Marshall Islands',
    ISO: 'MH',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Mauritania',
    ISO: 'MR',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Mauritius',
    ISO: 'MU',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 97200 - 97290.',
    country: 'Martinique',
    ISO: 'MQ',
    Format: '972NN',
    regex: '^972\\d{2}$',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 97600 - 97690.',
    country: 'Mayotte',
    ISO: 'YT',
    Format: '976NN',
    regex: '^976\\d{2}$',
  },
  {
    Note: 'US ZIP Code. Range 96941 - 96944.',
    country: 'Micronesia',
    ISO: 'FM',
    Format: 'NNNNN or NNNNN-NNNN',
    regex: '^\\d{5}(-{1}\\d{4})$',
  },
  {
    Note: 'The first two digits identify the state (or a part thereof), except for Nos. 00 to 16, which indicate delegaciones (boroughs) of the Federal District (Mexico City).',
    country: 'Mexico',
    ISO: 'MX',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'U.S. ZIP codes. Range 96941 - 96944.',
    country: 'Micronesia',
    ISO: 'FM',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Moldova',
    ISO: 'MD',
    Format: 'CCNNNN (CC-NNNN)',
    regex: '^[Mm][Dd][- ]{0,1}\\d{4}$',
  },
  {
    Note: 'Uses the French Postal System, but with an "MC" Prefix for Monaco.',
    country: 'Monaco',
    ISO: 'MC',
    Format: '980NN',
    regex: '^980\\d{2}$',
  },
  {
    Note: 'First digit: region / zone&#10;Second digit: province / district&#10;Last three digits: locality / delivery block[7]',
    country: 'Mongolia',
    ISO: 'MN',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Montenegro',
    ISO: 'ME',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Montserrat',
    ISO: 'MS',
    Format: 'MSR 1110-1350',
    regex: '^[Mm][Ss][Rr]\\s{0,1}\\d{4}$',
  },
  {
    Note: '',
    country: 'Morocco',
    ISO: 'MA',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Mozambique',
    ISO: 'MZ',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Myanmar',
    ISO: 'MM',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Postal Code ranges from 9000-9299 (NOTE: mainly 9000 is used)',
    country: 'Namibia',
    ISO: 'NA',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Nauru',
    ISO: 'NR',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Nepal',
    ISO: 'NP',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'The combination of the postcode and the housenumber gives a unique identifier of the address.',
    country: 'Netherlands',
    ISO: 'NL',
    Format: 'NNNN AA',
    regex: '^\\d{4}\\s{0,1}[A-Za-z]{2}$',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 98800 - 98890.',
    country: 'New Caledonia',
    ISO: 'NC',
    Format: '988NN',
    regex: '^988\\d{2}$',
  },
  {
    Note: 'Postcodes were originally intended for bulk mailing and were not needed for addressing individual items. However, new post codes for general use were phased in from June 2006 and came into force by July 2008.',
    country: 'New Zealand',
    ISO: 'NZ',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Nicaragua',
    ISO: 'NI',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Niger',
    ISO: 'NE',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Nigeria',
    ISO: 'NG',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: '',
    country: 'Niue',
    ISO: 'NU',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Part of the Australian postal code system.',
    country: 'Norfolk Island',
    ISO: 'NF',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'U.S. ZIP codes. Range 96950 - 96952.',
    country: 'Northern Mariana Islands',
    ISO: 'MP',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'From south to north',
    country: 'Norway',
    ISO: 'NO',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Deliveries to P.O. Boxes only.',
    country: 'Oman',
    ISO: 'OM',
    Format: 'NNN',
    regex: '^\\d{3}$',
  },
  {
    Note: 'Pakistan postal codes list',
    country: 'Pakistan',
    ISO: 'PK',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'U.S. ZIP codes. All locations 96940.',
    country: 'Palau',
    ISO: 'PW',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Panama',
    ISO: 'PA',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: '',
    country: 'Papua New Guinea',
    ISO: 'PG',
    Format: 'NNN',
    regex: '^\\d{3}$',
  },
  {
    Note: '',
    country: 'Paraguay',
    ISO: 'PY',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Peru',
    ISO: 'PE',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Philippines',
    ISO: 'PH',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'UK territory, but not UK postcode',
    country: 'Pitcairn Islands',
    ISO: 'PN',
    Format: 'AAAANAA one code: PCRN 1ZZ',
    regex: '^[Pp][Cc][Rr][Nn]\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: '',
    country: 'Poland',
    ISO: 'PL',
    Format: 'NNNNN (NN-NNN)',
    regex: '^\\d{2}[- ]{0,1}\\d{3}$',
  },
  {
    Note: '',
    country: 'Portugal',
    ISO: 'PT',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: '',
    country: 'Portugal',
    ISO: 'PT',
    Format: 'NNNN-NNN (NNNN NNN)',
    regex: '^\\d{4}[- ]{0,1}\\d{3}$',
  },
  {
    Note: 'U.S. ZIP codes. ZIP codes 006XX for NW PR, 007XX for SE PR, in which XX designates the town or post office and 009XX for the San Juan Metropolitan Area, in which XX designates the area or borough of San Juan. The last four digits identify an area within the post office. For example 00716-2604: 00716-for the east section of the city of Ponce and 2604 for Aceitillo St. in the neighborhood of Los Caobos. US Post office is changing the PR address format to the American one: 1234 No Name Avenue, San Juan, PR 00901.',
    country: 'Puerto Rico',
    ISO: 'PR',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Qatar',
    ISO: 'QA',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 97400 - 97490.',
    country: 'Réunion',
    ISO: 'RE',
    Format: '974NN',
    regex: '^974\\d{2}$',
  },
  {
    Note: 'Previously 99999 in Bucharest and 9999 in rest of country.',
    country: 'Romania',
    ISO: 'RO',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Placed on a line of its own.',
    country: 'Russia',
    ISO: 'RU',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Overseas Collectivity of France. French codes used.',
    country: 'Saint Barthélemy',
    ISO: 'BL',
    Format: '97133',
    regex: '^97133$',
  },
  {
    Note: 'Single code used for all addresses.',
    country: 'Saint Helena',
    ISO: 'SH',
    Format: 'STHL 1ZZ',
    regex: '^[Ss][Tt][Hh][Ll]\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: '',
    country: 'Saint Kitts and Nevis',
    ISO: 'KN',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Saint Lucia',
    ISO: 'LC',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Overseas Collectivity of France. French codes used.',
    country: 'Saint Martin',
    ISO: 'MF',
    Format: '97150',
    regex: '^97150$',
  },
  {
    Note: 'Overseas Collectivity of France. French codes used.',
    country: 'Saint Pierre and Miquelon',
    ISO: 'PM',
    Format: '97500',
    regex: '^97500$',
  },
  {
    Note: '',
    country: 'Saint Vincent and the Grenadines',
    ISO: 'VC',
    Format: 'CCNNNN',
    regex: '^[Vv][Cc]\\d{4}$',
  },
  {
    Note: 'With Italy, uses a five-digit numeric CAP of Emilia Romagna. Range 47890 and 47899',
    country: 'San Marino',
    ISO: 'SM',
    Format: '4789N',
    regex: '^4789\\d$',
  },
  {
    Note: '',
    country: 'Sao Tome and Principe',
    ISO: 'ST',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'A complete 13-digit code has 5-digit number representing region, sector, city, and zone; 4-digit X between 2000 and 5999; 4-digit Y between 6000 and 9999 [3]. Digits of 5-digit code may represent postal region, sector, branch, section, and block respectively [4].',
    country: 'Saudi Arabia',
    ISO: 'SA',
    Format: 'NNNNN for PO Boxes. NNNNN-NNNN for home delivery.',
    regex: '^\\d{5}(-{1}\\d{4})?$',
  },
  {
    Note: 'The letters CP or C.P. are often written in front of the postcode. This is not a country code, but simply an abbreviation for "code postal".',
    country: 'Senegal',
    ISO: 'SN',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Poštanski adresni kod (PAK)',
    country: 'Serbia',
    ISO: 'RS',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Serbia',
    ISO: 'RS',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Seychelles',
    ISO: 'SC',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Sint Maarten',
    ISO: 'SX',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Sierra Leone',
    ISO: 'SL',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Singapore',
    ISO: 'SG',
    Format: 'NN',
    regex: '^\\d{2}$',
  },
  {
    Note: '',
    country: 'Singapore',
    ISO: 'SG',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Each building has its own unique postcode.',
    country: 'Singapore',
    ISO: 'SG',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'with Czech Republic from west to east, Poštové smerovacie číslo (PSČ) - postal routing number.',
    country: 'Slovakia',
    ISO: 'SK',
    Format: 'NNNNN (NNN NN)',
    regex: '^\\d{5}\\s\\(\\d{3}\\s\\d{2}\\)$',
  },
  {
    Note: '',
    country: 'Slovenia',
    ISO: 'SI',
    Format: 'NNNN (CC-NNNN)',
    regex: '^([Ss][Ii][- ]{0,1}){0,1}\\d{4}$',
  },
  {
    Note: '',
    country: 'Solomon Islands',
    ISO: 'SB',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'A 5 digit code has been publicized, but never taken into use.',
    country: 'Somalia',
    ISO: 'SO',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Postal codes are allocated to individual Post Office branches, some have two codes to differentiate between P.O. Boxes and street delivery addresses. Included Namibia (ranges 9000-9299) until 1992, no longer used.',
    country: 'South Africa',
    ISO: 'ZA',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'One code for all addresses.',
    country: 'South Georgia and the South Sandwich Islands',
    ISO: 'GS',
    Format: 'SIQQ 1ZZ',
    regex: '^[Ss][Ii][Qq]{2}\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: '',
    country: 'South Korea',
    ISO: 'KR',
    Format: 'NNNNNN (NNN-NNN)',
    regex: '^\\d{6}\\s\\(\\d{3}-\\d{3}\\)$',
  },
  {
    Note: 'First two indicate the province, range 01-52',
    country: 'Spain',
    ISO: 'ES',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Reference: http://mohanjith.net/ZIPLook/ Incorporates Colombo postal districts, e.g.: Colombo 1 is "00100". You can search for specific postal codes here.',
    country: 'Sri Lanka',
    ISO: 'LK',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Sudan',
    ISO: 'SD',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Suriname',
    ISO: 'SR',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: "The letter identifies one of the country's four districts.",
    country: 'Swaziland',
    ISO: 'SZ',
    Format: 'ANNN',
    regex: '^[A-Za-z]\\d{3}$',
  },
  {
    Note: '',
    country: 'Sweden',
    ISO: 'SE',
    Format: 'NNNNN (NNN NN)',
    regex: '^\\d{3}\\s*\\d{2}$',
  },
  {
    Note: 'With Liechtenstein, ordered from west to east. In Geneva and other big cities, like Basel, Bern, Zurich, there may be one or two digits after the name of the city when the generic City code (1211) is used instead of the area-specific code (1201, 1202...), e.g.: 1211 Geneva 13. The digit identifies the post office. This addressing is generally used for P.O. box deliveries.',
    country: 'Switzerland',
    ISO: 'CH',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'Norway postal codes',
    country: 'Svalbard and Jan Mayen',
    ISO: 'SJ',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'A 4-digit system has been announced. Status unknown.',
    country: 'Syria',
    ISO: 'SY',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'The first three digits of the postal code are required; the last two digits are optional. Codes are known as youdi quhao (郵遞區號), and are also assigned to Senkaku Islands (Diaoyutai), though Japanese-administered, the Pratas Islands and the Spratly Islands. See List of postal codes in Taiwan.',
    country: 'Taiwan',
    ISO: 'TW',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Retained system from former Soviet Union.',
    country: 'Tajikistan',
    ISO: 'TJ',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: '',
    country: 'Tanzania',
    ISO: 'TZ',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'The first two specify the province, numbers as in ISO 3166-2:TH, the third and fourth digits specify a district (amphoe)',
    country: 'Thailand',
    ISO: 'TH',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'Togo',
    ISO: 'TG',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Tokelau',
    ISO: 'TK',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Tonga',
    ISO: 'TO',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'First two digits specify a postal district (one of 72), next two digits a carrier route, last two digits a building or zone along that route',
    country: 'Trinidad and Tobago',
    ISO: 'TT',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Single code used for all addresses.',
    country: 'Tristan da Cunha',
    ISO: 'SH',
    Format: 'TDCU 1ZZ',
    regex: '^[Tt][Dd][Cc][Uu]\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: '',
    country: 'Tunisia',
    ISO: 'TN',
    Format: 'NNNN',
    regex: '^\\d{4}$',
  },
  {
    Note: 'First two digits are the city numbers.[8]',
    country: 'Turkey',
    ISO: 'TR',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Retained system from former Soviet Union.',
    country: 'Turkmenistan',
    ISO: 'TM',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Single code used for all addresses.',
    country: 'Turks and Caicos Islands',
    ISO: 'TC',
    Format: 'TKCA 1ZZ',
    regex: '^[Tt][Kk][Cc][Aa]\\s{0,1}[1][Zz]{2}$',
  },
  {
    Note: '',
    country: 'Tuvalu',
    ISO: 'TV',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Uganda',
    ISO: 'UG',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Ukraine',
    ISO: 'UA',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: '',
    country: 'United Arab Emirates',
    ISO: 'AE',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Known as the postcode. The first letter(s) indicate the postal area, such as the town or part of London. Placed on a separate line below the city (or county, if used). The UK postcode is made up of two parts separated by a space. These are known as the outward postcode and the inward postcode. The outward postcode is always one of the following formats: AN, ANN, AAN, AANN, ANA, AANA, AAA. The inward postcode is always formatted as NAA. A valid inward postcode never contains the letters: C, I, K, M, O or V. The British Forces Post Office has a different system, but as of 2012 has also adopted UK-style postcodes that begin with "BF1" for electronic compatibility.',
    country: 'United Kingdom',
    ISO: 'GB',
    Format: 'A(A)N(A/N)NAA (A[A]N[A/N] NAA)',
    regex: '^[A-Z]{1,2}[0-9R][0-9A-Z]?\\s*[0-9][A-Z-[CIKMOV]]{2}',
  },
  {
    Note: 'Known as the ZIP Code with five digits 99999* or the ZIP+4 Code with nine digits 99999-9999* (while the minimum requirement is the first five digits, the U.S. Postal Service encourages everyone to use all nine). Also used by the former US Pacific Territories: Federated States of Micronesia; Palau; and the Marshall Islands, as well as in current US territories American Samoa, Guam, Northern Mariana Islands, Puerto Rico, and the United States Virgin Islands. An individual delivery point may be represented as an 11-digit number, but these are usually represented by Intelligent Mail barcode or formerly POSTNET bar code.',
    country: 'United States',
    ISO: 'US',
    Format: 'NNNNN (optionally NNNNN-NNNN)',
    regex: '^\\b\\d{5}\\b(?:[- ]{1}\\d{4})?$',
  },
  {
    Note: '',
    country: 'Uruguay',
    ISO: 'UY',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'U.S. ZIP codes. Range 00801 - 00851.',
    country: 'U.S. Virgin Islands',
    ISO: 'VI',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'Почтовые индексы',
    country: 'Uzbekistan',
    ISO: 'UZ',
    Format: 'NNN NNN',
    regex: '^\\d{3} \\d{3}$',
  },
  {
    Note: '',
    country: 'Vanuatu',
    ISO: 'VU',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: 'Single code used for all addresses. Part of the Italian postal code system.',
    country: 'Vatican',
    ISO: 'VA',
    Format: '120',
    regex: '^120$',
  },
  {
    Note: '',
    country: 'Venezuela',
    ISO: 'VE',
    Format: 'NNNN or NNNN A',
    regex: '^\\d{4}(\\s[a-zA-Z]{1})?$',
  },
  {
    Note: 'First two indicate a province.',
    country: 'Vietnam',
    ISO: 'VN',
    Format: 'NNNNNN',
    regex: '^\\d{6}$',
  },
  {
    Note: 'Overseas Department of France. French codes used. Range 98600 - 98690.',
    country: 'Wallis and Futuna',
    ISO: 'WF',
    Format: '986NN',
    regex: '^986\\d{2}$',
  },
  {
    Note: 'System for Sana\'a Governorate using geocoding "عنواني" based on the OpenPostcode algorithm is inaugurated in 2014.[9]',
    country: 'Yemen',
    ISO: 'YE',
    Format: '- no codes -',
    regex: '',
  },
  {
    Note: '',
    country: 'Zambia',
    ISO: 'ZM',
    Format: 'NNNNN',
    regex: '^\\d{5}$',
  },
  {
    Note: 'System is being planned.',
    country: 'Zimbabwe',
    ISO: 'ZW',
    Format: '- no codes -',
    regex: '',
  },
]
